import React, { useContext, createContext, useCallback } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Typography from "@mui/material/Typography";
import Success from "./NewGreenhouseSuccess";
import { AppContext } from "../Context";
import { Button, Checkbox, FormControlLabel, FormHelperText, Grid, TextField } from "@mui/material";
import { useForm, FormProvider, useFormContext, UseFormRegister, SubmitHandler } from "react-hook-form";
import axios from "axios";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { IBay } from "../interfaces/IBay";
import { IZone } from "../interfaces/IZone";
import { IBench } from "../interfaces/IBench";
import ConfirmDialog, { confirmDialog } from "../components/ConfirmDialog";
import NextIcon from '@mui/icons-material/NavigateNext';
import BackIcon from '@mui/icons-material/NavigateBefore';



// Step titles
const labels = ["Create Greenhouse", "Create Bays", "Create Zones", "Create Benches"];
const handleSteps = (step: number, setActiveStep: React.Dispatch<React.SetStateAction<number>>, setOpen: React.Dispatch<React.SetStateAction<boolean>>) => {
  switch (step) {
    case 0:
      return <NewGreenhouseStepOne setActiveStep={setActiveStep} />;
    case 1:
      return <NewGreenhouseStepTwo setActiveStep={setActiveStep} />;
    case 2:
      return <NewGreenhouseStepThree setActiveStep={setActiveStep} />;
    case 3:
      return <NewGreenhouseStepFour setActiveStep={setActiveStep} setOpen={setOpen} />;
    case 5:
    default:
      throw new Error("Unknown step");
  }
};

const onSubmit = (data: any) => {
  console.log("SUBMIT DATA", data);
  submitData(data);

};

interface IFormInput {
  greenhouseId: number,
  greenhouseName: string,
  greenhouseDescription: string,
  greenhouseLength: number,
  greenhouseWidth: number,
  greenhouseHeatedFloors: boolean,
  bayName: string,
  bayDescription: string,
  bayLength: number,
  bayWidth: number,
  bayGrowLights: boolean,
  zoneName: string,
  zoneDescription: string,
  zoneColorName: string,
  zoneLength: number,
  zoneWidth: number,
}

interface GreenhouseProps {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

interface GreenhouseStepProps {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>
}

interface FinalStepProp {
  setActiveStep: React.Dispatch<React.SetStateAction<number>>
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const submitData = (data: any) => {
  axios.post(`${process.env.REACT_APP_ENDPOINT}/api/Greenhouses/Create`, {
    greenhouseId: data.greenhouseId,
    greenhouseName: data.greenhouseName,
    greenhouseDescription: data.greenhouseDescription,
    greenhouseLength: data.greenhouseLength,
    greenhouseWidth: data.greenhouseWidth,
    bayName: data.bayName,
    bayDescription: data.bayDescription,
    bayLength: data.bayLength,
    bayWidth: data.bayWidth,
    bayHeatedFloors: data.bayHeatedFloors,
    bayGrowLights: data.bayGrowLights,
    bayDirection: data.bayDirection,
    zoneName: data.zoneName,
    zoneDescription: data.zoneDescription,
    zoneColorName: data.zoneColorName,
    zoneLength: data.zoneLength,
    zoneWidth: data.zoneWidth,
    zoneHeatedFloors: data.zoneHeatedFloors,
    zoneGrowLights: data.zoneGrowLights,
    zoneIsGermination: data.zoneIsGermination
  }).then((data) => {
    console.log("Response Data", data);
    if (data.status === 201) {
      // setOpen(false);
      // GetGridData(setRows);
    };
  });
}


export default function NewGreenhouse(props: GreenhouseProps) {
  const methods = useForm();
  const [activeStep, setActiveStep] = React.useState(0);
  const [formValues, setFormValues] = React.useState<IFormInput>();
  const { register, handleSubmit, control, formState: { errors }, getValues } = useForm<IFormInput>();



  return (
      <FormProvider {...methods}>
        <Box component="form">
          <Stepper activeStep={activeStep} sx={{ pt: 2}} alternativeLabel>
            {labels.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {handleSteps(activeStep, setActiveStep, props.setOpen)}
        </Box>
      </FormProvider>
  )
}

const NewGreenhouseStepOne = (props: GreenhouseStepProps) => {
  const { register } = useFormContext();
  return (
    <Box>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" align="center" fontWeight="700">
          Create a New Greenhouse
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={6} lg={6}>
          <TextField
            fullWidth
            label="Greenhouse Name"
            placeholder="Greenhouse XYZ"
            type="text"
            variant="filled"
            {...register("greenhouseName")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Greenhouse Description"
            placeholder="N/W Garden"
            type="text"
            {...register("greenhouseDescription")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Length (FT)"
            placeholder="20.1"
            type="number"
            {...register("greenhouseLength")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Width (FT)"
            placeholder="15.5"
            type="number"
            {...register("greenhouseWidth")}

          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Total Space (SQFT)"
            placeholder="15.5"
            type="number"
            defaultValue={0}
            {...register("greenhouseSize")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Last Updated"
            type="date"
            {...register("greenhouseLastUpdated")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Percent Allocated Space (%)"
            placeholder="15.5"
            type="number"
            disabled
            {...register("greenhouseAllocatedSpace")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Percent Available Space (%)"
            placeholder="15.5"
            type="number"
            disabled
            {...register("greenhouseAvailableSpace")}
          />
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            label="Heated Floors?"
            control={
              <Checkbox sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} {...register("greenhouseHeatedFloors")} />
            }
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          endIcon={<NextIcon />}
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="success"
          onClick={() => props.setActiveStep(1)}>Next
        </Button>
      </Box>
    </Box>
  );
}

const NewGreenhouseStepTwo = ({ setActiveStep }: { setActiveStep: React.Dispatch<React.SetStateAction<number>> }) => {
  const { register, getValues, setValue } = useFormContext();
  return (
    <Box>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" align="center" fontWeight="700">
          Create a New Bay
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <TextField
          sx={{ display: 'none' }}
          fullWidth
          label="ID"
          type="number"
          defaultValue={0}
          {...register("id")}
        />
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Bay Name"
            placeholder="Bay XYZ"
            type="text"
            {...register("name")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Description"
            placeholder="Bay 1/2/3"
            type="text"
            {...register("description")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Length"
            placeholder="20.1"
            type="number"
            {...register("length", {
              valueAsNumber: true,
              onChange: (evt) => {
                const [width] = getValues(['width'])
                const calculatedSize = (parseFloat(evt.target.value) * width);
                if (!isNaN(calculatedSize)) {
                  setValue('size', calculatedSize)
                }
              }
            })}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Width"
            placeholder="15.5"
            type="number"
            {...register("width", {
              valueAsNumber: true,
              onChange: (evt) => {
                const [length] = getValues(['length'])
                const calculatedSize = (parseFloat(evt.target.value) * length);
                if (!isNaN(calculatedSize)) {
                  setValue('size', calculatedSize)
                }
              }
            })}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Total Size"
            placeholder="5000"
            type="number"
            defaultValue={0}
            disabled
            {...register("size")}
          />
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            label="Growing Lights?"
            control={
              <Checkbox {...register("isGrowLights")} sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} />
            }
          />
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            label="Germination?"
            control={
              <Checkbox {...register("isGermination")} sx={{ '& .MuiSvgIcon-root': { fontSize: 30 } }} />
            }
          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Button
          startIcon={<BackIcon />}
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="primary"
          onClick={() => setActiveStep(0)}>Back
        </Button>
        <Button
          endIcon={<NextIcon />}
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="success"
          onClick={() => setActiveStep(2)}>Next
        </Button>
      </Box>
    </Box>
  );
}

const NewGreenhouseStepThree = ({ setActiveStep }: { setActiveStep: React.Dispatch<React.SetStateAction<number>> }) => {
  const { register } = useFormContext();
  return (
    <Box>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" align="center" fontWeight="700">
          Create a New Zone
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Zone Name"
            placeholder="Zone Blue"
            type="text"
            {...register("zoneName")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Description"
            placeholder="Zone 1/2/3"
            type="text"
            {...register("zoneDescription")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Length"
            placeholder="20.1"
            type="number"
            defaultValue={0}
            {...register("zoneLength")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Width"
            placeholder="15.5"
            type="number"
            defaultValue={0}
            {...register("zoneWidth")}

          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Size"
            placeholder="21.5"
            type="number"
            disabled
            defaultValue={0}
            {...register("zoneSize")}

          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Color"
            placeholder="Green"
            type="text"
            {...register("zoneColorName")}

          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Button
          startIcon={<BackIcon />}
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="primary"
          onClick={() => setActiveStep(1)}>Back
        </Button>
        <Button
          endIcon={<NextIcon />}
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="success"
          onClick={() => setActiveStep(3)}>Next
        </Button>
      </Box>
    </Box>
  );
}

const NewGreenhouseStepFour = ({ setActiveStep, setOpen }: { setActiveStep: React.Dispatch<React.SetStateAction<number>>, setOpen: React.Dispatch<React.SetStateAction<boolean>> }) => {
  const { register, handleSubmit } = useFormContext();
  return (
    <Box>
      <Box sx={{ my: 4 }}>
        <Typography variant="h4" align="center" fontWeight="700">
          Create a New Bench
        </Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Bench Name"
            placeholder="Bench N/W Green"
            type="text"
            {...register("benchName")}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Description"
            placeholder="Bench 1/2/3"
            type="text"
            {...register("benchDescription")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Length"
            placeholder="20.1"
            type="number"
            defaultValue={0}
            {...register("benchLength")}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Width"
            placeholder="15.5"
            type="number"
            defaultValue={0}
            {...register("benchWidth")}

          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Size"
            placeholder="32"
            type="number"
            defaultValue={0}
            {...register("benchSize")}

          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            fullWidth
            label="Tray Capacity"
            placeholder="32"
            type="number"
            defaultValue={0}
            {...register("benchTrayCapacity")}

          />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end",}}>
      <Button
          startIcon={<BackIcon />}
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="primary"
          onClick={() => setActiveStep(2)}>Back
        </Button>
        <Button
          size="large"
          variant="contained"
          sx={{ mt: 3, ml: 1 }}
          color="success" onClick={() => {
            confirmDialog("Are you sure you want to save this greenhouse?", handleSubmit(onSubmit));
            setOpen(false);
          }}
        >Complete
        </Button>
      </Box>
    </Box>
  );
}
